function redirectToLogin() {
  globalThis.location.replace(
    `${import.meta.env.VITE_APPS_SERVER_URL}/login?redirectUrl=${globalThis.location.href}`,
  );
}

export const redirect = {
  toLogin: redirectToLogin,
};
